import { FormattedMessage } from "react-intl";
import * as Yup from "yup";
import React from "react";
import { useSelector } from "react-redux";

const Data = () => {
  const data = useSelector((state) => state.Auth.userInfo.profileData);
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required(<FormattedMessage id={`Auth.passwordValidations`} />)
      .matches(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*.-]).{8,}$/,
        " يجب أن تتكون كلمة السر من ثمانية أحرف على الاقل وباللغة الانكليزية وأن تتضمن أحرف كبيرة مثل(ABC) وأحرف صغيرة مثل (abc) وأحرف خاصة مثل (!@#$%^*.) وأرقام مثل (123)"
      )
      .min(8, <FormattedMessage id={`Auth.passwordValidationsTwo`} />),
  });
  const formikProps = {
    validationSchema,
    formik: {
      onChangeValidate: false,
      onBlurValidate: false,
    },
    initialValues: {
      full_name: data.name,
      father_name: data.father_name,
      state: data.state_name,
      location: data.location_name,
      email: data.email,
      phone: Number(data.login).toString(),
      password: "",
    },
  };
  return { formikProps };
};

export default Data;
